import React from 'react';
import { Shield, Heart, TrendingUp, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../context/LanguageContext';

const ProductCard = ({ image, alt, iconBg, Icon, titleKey, descKey, bulletKeys, btnClass, scrollToSection }) => {
  const { t } = useLanguage();
  return (
    <Card className="group hover:shadow-2xl transition-all duration-300 hover:scale-105 border-2 border-slate-200 hover:border-emerald-700 overflow-hidden">
      <div className="h-56 overflow-hidden">
        <img src={image} alt={alt} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
      </div>
      <CardContent className="p-8">
        <div className={`w-16 h-16 ${iconBg} rounded-full flex items-center justify-center mb-6`}>
          <Icon className="w-8 h-8 text-white" />
        </div>
        <h3 className="text-2xl font-bold text-slate-900 mb-4">{t(titleKey)}</h3>
        <p className="text-slate-600 mb-6 leading-relaxed">{t(descKey)}</p>
        <ul role="list" className="space-y-3 mb-6">
          {bulletKeys.map(k => (
            <li role="listitem" key={k} className="flex items-start">
              <CheckCircle className="w-5 h-5 text-amber-700 mr-2 mt-0.5 flex-shrink-0" />
              <span className="text-slate-700">{t(k)}</span>
            </li>
          ))}
        </ul>
        <Button onClick={() => scrollToSection('contact')} className={`w-full ${btnClass} text-white transition-colors duration-300`}>
          {t('learn_more')}
        </Button>
      </CardContent>
    </Card>
  );
};

const PRODUCTS = [
  { image: 'https://images.pexels.com/photos/4473871/pexels-photo-4473871.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', alt: 'Term Life Insurance', iconBg: 'bg-emerald-700', Icon: Shield, titleKey: 'term_life_title', descKey: 'term_life_desc', bulletKeys: ['term_life_bullet1', 'term_life_bullet2', 'term_life_bullet3'], btnClass: 'bg-emerald-900 hover:bg-emerald-800' },
  { image: 'https://images.pexels.com/photos/7641906/pexels-photo-7641906.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', alt: 'Mortgage Protection', iconBg: 'bg-amber-600', Icon: Shield, titleKey: 'mortgage_title', descKey: 'mortgage_desc', bulletKeys: ['mortgage_bullet1', 'mortgage_bullet2', 'mortgage_bullet3'], btnClass: 'bg-emerald-900 hover:bg-amber-700' },
  { image: 'https://images.unsplash.com/photo-1758691031036-5b7b635e30b8', alt: 'Final Expense', iconBg: 'bg-emerald-700', Icon: Heart, titleKey: 'final_expense_title', descKey: 'final_expense_desc', bulletKeys: ['final_expense_bullet1', 'final_expense_bullet2', 'final_expense_bullet3'], btnClass: 'bg-emerald-900 hover:bg-emerald-800' },
  { image: 'https://images.pexels.com/photos/15678267/pexels-photo-15678267.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940', alt: 'Indexed Universal Life', iconBg: 'bg-amber-600', Icon: TrendingUp, titleKey: 'iul_title', descKey: 'iul_desc', bulletKeys: ['iul_bullet1', 'iul_bullet2', 'iul_bullet3'], btnClass: 'bg-emerald-900 hover:bg-amber-700' },
];

const ProductsSection = ({ scrollToSection }) => {
  const { t } = useLanguage();
  return (
    <section id="products" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">{t('products_title')}</h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">{t('products_subtitle')}</p>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {PRODUCTS.map(p => (
            <ProductCard key={p.titleKey} {...p} scrollToSection={scrollToSection} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductsSection;
